import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import Logo from "../assests/images/logo.png";
import { FormatDate } from "../components/Forms";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    padding: 26,
    position: "relative",
  },
  section: {
    flexDirection: "column",
    flexGrow: 1,
    border: 1,
    display: "flex",
  },
  text: {
    fontSize: 13,
    fontFamily: "Times-Roman",
    textAlign: "center",
    borderBottom: 1,
    width: "100%",
  },
  headertext: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    borderBottom: 1,
    width: "100%",
    padding: 2,
  },
  head: {
    fontSize: 10,
    display: "flex",
    flexDirection: "row",
    textAlign: "center",
  },
  invoice: {
    flex: 200,
    fontWeight: "bolder",
    fontSize: 13,
  },
  table: {
    display: "flex",
    borderBottom: 0.5,
    padding: 6,
    justifyContent: "flex-end",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  tableCell: {
    flex: 4,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  producthead: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    borderBottom: 1,
  },
  producttitle: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    padding: 5,
    borderBottom: 1,
  },
  productbody: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    padding: 5,
  },
  bodydescription: {
    height: 500,
  },
  no: {
    width: "10%",
    textAlign: "center",
    padding: 5,
  },
  particular: {
    width: "35%",
    textAlign: "left",
    padding: 5,
    flexWrap: "wrap",
  },
  qty: {
    width: "10%",
    textAlign: "center",
    padding: 5,
  },
  rateinctax: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  rate: {
    width: "15%",
    textAlign: "center",
    padding: 5,
  },
  amount: {
    width: "20%",
    textAlign: "center",
    padding: 5,
  },
  footer: {
    fontSize: 9,
    display: "flex",
    justifyContent: "flex-end",
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  footerleft: {
    height: 62,
    borderBottom: 0.5,
  },
  footerCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    width: "100%",
  },
  right: {
    textAlign: "right",
  },
  totalBox: {
    position: "absolute",
  },
  w70: {
    width: "70%",
  },
  w30: {
    width: "30%",
  },
  priceRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
    borderBottom: 1,
    flexGrow: 15,
  },
  priceCell: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    flexGrow: 10,
    borderRight: 1,
    padding: 4,
    flexShrink: 1,
  },
  overall: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    paddingVertical: 5,
    padding: 5,
    flexGrow: 2.5,
    marginTop: 6,
  },
  paymentDetails: {
    marginTop: 10,
    marginBottom: 10,
  },
  paymentRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingVertical: 2,
  },
  paymentMethod: {
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  paymentAmount: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    textAlign: "right",
  },
  signbox: {
    fontSize: 9,
    display: "flex",
  },
  signdesk: {
    height: 55,
  },
  signbill: {
    flexDirection: "row",
  },
  customsign: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    flexGrow: 200,
    marginTop: 45,
    paddingHorizontal: 10,
  },
  docs: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    marginTop: 45,
    paddingHorizontal: 10,
  },
  declration: {
    fontSize: 8,
    padding: 1,
  },
  boxdetails: {
    display: "flex",
    flexDirection: "row",
    borderBottom: 1,
  },
  boxdetail: {
    display: "flex",
    flexDirection: "row",
    borderBottom: 1,
  },
  boxdetailss: {
    display: "flex",
    flexDirection: "row",
  },
  box: {
    fontSize: 9,
    width: "50%",
    padding: 5,
  },
  brdright: { borderRight: 1 },
  brdrights: { borderRight: 1, borderBottom: 1 },
  brdrightss: { borderBottom: 1 },
  brdtop: {
    borderTopWidth: 1,
    borderTopColor: "#000",
    borderTopStyle: "solid",
    width: "50%",
    paddingBottom: 1,
  },
  print: {
    fontSize: 9,
    textAlign: "right",
  },
  companyname: {
    fontWeight: "bold",
    fontSize: 9,
  },
  billed: {
    fontSize: 11,
    fontWeight: "bold",
  },
  boldText: {
    fontFamily: "Times-Roman",
    fontWeight: "bold",
    fontSize: 11,
  },
  ewayno: {
    marginBottom: 1,
    fontSize: 11,
    fontWeight: "bold",
  },
  stateof: {
    fontSize: 11,
    fontWeight: "bold",
  },
  remarks: {
    fontSize: 6,
  },
  watermark: {
    position: "absolute",
    top: "15%",
    left: "5%",
    right: "0%",
    width: "100%",
    height: "70%",
    opacity: 0.1,
    margin: "0 auto",
    display: "flex",
  },
});

// Function to convert rupees to words
const convertRupeesToWordsWithBreaks = (amount) => {
  const ones = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Lakh", "Crore"];

  function convertGroup(number, thousandIndex) {
    if (number === 0) return "";
    let str = "000" + number;
    str = str.slice(-3);
    const hundred = parseInt(str[0], 10);
    const ten = parseInt(str[1], 10);
    const one = parseInt(str[2], 10);
    let words = [];
    if (hundred > 0) words.push(ones[hundred] + " Hundred");
    if (ten === 1) {
      words.push(teens[one]);
    } else {
      if (ten > 0) words.push(tens[ten]);
      if (one > 0) words.push(ones[one]);
    }
    if (thousandIndex > 0 && words.length > 0)
      words.push(thousands[thousandIndex]);
    return words.join(" ");
  }

  function convertIntegerPart(integerPart) {
    const groups = [];
    let thousandIndex = 0;
    while (integerPart > 0) {
      groups.push(
        convertGroup(
          integerPart % (thousandIndex === 1 ? 100 : 1000),
          thousandIndex
        )
      );
      integerPart = Math.floor(
        integerPart / (thousandIndex === 1 ? 100 : 1000)
      );
      thousandIndex++;
    }
    const resultGroups = groups.reverse().filter((group) => group !== "");
    const lastGroupIndex = resultGroups.length - 1;
    const formattedGroups = resultGroups.map((group, index) =>
      index === lastGroupIndex ? group : group
    );
    return formattedGroups.join(" ");
  }

  function convertDecimalPart(decimalPart) {
    if (decimalPart === 0) return "";
    let paise = Math.round(decimalPart * 100);
    return convertGroup(paise, 0) + " Paise";
  }

  const integerPart = Math.floor(amount);
  const decimalPart = amount - integerPart;
  const integerWords = convertIntegerPart(integerPart);
  const decimalWords = convertDecimalPart(decimalPart);
  const result =
    integerWords + " Rupees" + (decimalWords ? "\nAnd " + decimalWords : "");
  return result.trim();
};

const Pdf = ({ data, type }) => {
  console.log("data", data);
  const IGST = data.product.reduce(
    (acc, product) => acc + parseFloat(product.IGST),
    0
  );
  const SGST = data.product.reduce(
    (acc, product) => acc + parseFloat(product.SGST),
    0
  );
  const CGST = data.product.reduce(
    (acc, product) => acc + parseFloat(product.CGST),
    0
  );

  const [userdata, setUserData] = useState([]);
  const filteredUserData = userdata.filter(
    (item) => item.company_id === data.party_details.company_id
  );

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/company.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ search_text: "" }),
      });
      if (!response.ok) throw new Error("Failed to fetch data");
      const responseData = await response.json();
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const words = convertRupeesToWordsWithBreaks(data.total);

  // Split products into chunks of 17
  const productsPerPage = 20;
  const productChunks = [];
  for (let i = 0; i < data.product.length; i += productsPerPage) {
    productChunks.push(data.product.slice(i, i + productsPerPage));
  }

  // Render header section (Invoice number, addresses, etc.)
  const renderHeader = () => (
    <>
      <View style={styles.headertext}>
        <View style={styles.head}>
          <Text style={styles.invoice}>Invoice Bill</Text>
        </View>
      </View>
      <View style={styles.boxdetail}>
        <View style={[styles.box, styles.brdright]}>
          <Text>Invoice No: {data.bill_no}</Text>
        </View>
        <View style={styles.box}>
          <Text>Date: {FormatDate(data.bill_date)}</Text>
        </View>
      </View>
      <View style={styles.boxdetailss}>
        <View style={[styles.box, styles.brdrights]}>
          <Text style={[styles.billed, styles.boldText]}>
            Billed By: {data.company_details.company_name}
          </Text>
          <Text>Address: {data.company_details.address}</Text>
          <Text>
            Phone Number: {data.company_details.mobile_number},9751045074
          </Text>
        </View>
        <View style={[styles.box, styles.brdrightss]}>
          <Text style={styles.ewayno}>To: {data.party_name}</Text>
          <Text style={styles.ewayno}>Address: {data.address}</Text>
          <Text style={styles.ewayno}>Mobile Number: {data.mobile_number}</Text>
        </View>
      </View>
    </>
  );

  // Render footer section (total box, customer sign, etc.)
  const renderFooter = () => (
    <>
      <View style={styles.boxdetails}>
        <View style={[styles.box, styles.brdright, styles.w70]}></View>
        <View style={[styles.box, styles.w30]}>
          <Text>Sub Total: {data.sub_total}</Text>
          <Text>
            Discount:
            {data.discount_type === "Discount Amount"
              ? data.discount
              : ((data.sub_total * data.discount) / 100).toFixed(2)}
          </Text>
        </View>
      </View>
      <View style={styles.footer}>
        <View style={styles.priceRow}>
          <Text style={[styles.priceCell, styles.w70]}>
            Amount in words: {words} Only
          </Text>
          <Text style={[styles.overall, styles.w30]}>
            Total Amount: {data.total}
          </Text>
        </View>
      </View>
      <View style={styles.signbox}>
        <View style={styles.signdesk}>
          <View style={styles.signbill}>
            <View style={styles.customsign}>
              <Text>Customer Sign</Text>
            </View>
            <Text style={styles.docs}>
              For {data.company_details.company_name}
            </Text>
          </View>
        </View>
      </View>
    </>
  );

  return (
    <Document>
      {productChunks.map((chunk, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          <Image style={styles.watermark} src={Logo} />
          <View style={styles.section}>
            {renderHeader()}
            <View style={styles.producthead}>
              <View style={styles.producttitle}>
                <Text style={styles.no}>S No</Text>
                <Text style={styles.particular}>Particulars</Text>
                <Text style={styles.qty}>Qty</Text>
                <Text style={styles.qty}>Unit</Text>
                <Text style={styles.qty}>Net Rate</Text>
                <Text style={styles.amount}>Total Amount</Text>
              </View>
              <View style={styles.bodydescription}>
                {chunk.map((product, index) => (
                  <View style={styles.productbody} key={index}>
                    <Text style={styles.no}>
                      {pageIndex * productsPerPage + index + 1}
                    </Text>
                    <Text style={styles.particular}>
                      {product.product_name}
                    </Text>
                    <Text style={styles.qty}>{product.qty}</Text>
                    <Text style={styles.qty}>{product.unit_name}</Text>
                    <Text style={styles.qty}>{product.price_unit}</Text>
                    <Text style={styles.amount}>{product.total_amt}</Text>
                  </View>
                ))}
                {/* Add empty rows to fill up to 18 */}
                {Array.from({ length: productsPerPage - chunk.length }).map(
                  (_, index) => (
                    <View style={styles.productbody} key={`empty-${index}`}>
                      <Text style={styles.no}></Text>
                      <Text style={styles.particular}></Text>
                      <Text style={styles.qty}></Text>
                      <Text style={styles.qty}></Text>
                      <Text style={styles.qty}></Text>
                      <Text style={styles.qty}></Text>
                      <Text style={styles.amount}></Text>
                    </View>
                  )
                )}
              </View>
            </View>
            {renderFooter()}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default Pdf;
